<template>
  <main
  v-loading="loading">
    <h3 v-html="$t('SelectBrand')" />
    <el-row>
      <el-col :span="12" :offset="6">
        <el-select
        v-model="vbrand"
        placeholder="Select"
        size="large"
        v-if="brands"
        @change="$emit(
          'setBrand',
          {'brand':
          {value: vbrand,
          id: 3}
          })"
        filterable
        class="select">
          <el-option
          v-for="brand in brands"
          :key="brand.id"
          :label="brand.name"
          :value="brand.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
  </main>
</template>

<script>
import CompatibilityServices from '@/api/CompatibilityServices';
import LoaderMixin from '@/mixins/Loader.mixin';

export default {
  name: 'SelectBrand',
  mixins: [LoaderMixin],
  props: {
    appMarket: {
      type: String,
      default: '',
    },
    appLocale: {
      type: String,
      default: '',
    },
    compatibilityType: {
      type: String,
      default: '',
    },
    articleType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      brands: {},
      vbrand: '',
    };
  },
  methods: {
    async getApi() {
      const requestHeaders = {
        headers: {
          'app-market': this.appMarket,
          'app-locale': this.appLocale,
          apiKey: process.env.VUE_APP_APIKEY,
        },
      };
      const response = await CompatibilityServices
        .getBrands(requestHeaders, this.compatibilityType, this.articleType);
      this.brands = response.data.body.brands;
    },
  },
  mounted() {
    this.getApi();
  },
};
</script>

<style scoped lang="scss">

</style>
